/**
 * Data Transfer Object (DTO) for assignment status.
 * Represents the wire format used by the backend API.
 */
export enum AssignmentStatusDTO {
  CONFIRMED = 'CONFIRMED',
  UNCONFIRMED = 'UNCONFIRMED',
  DRAFT = 'DRAFT',
}

/**
 * Type alias for assignment status in API requests.
 */
export type AssignmentStatusRequest = AssignmentStatusDTO;

/**
 * Type alias for assignment status in API responses.
 */
export type AssignmentStatusResponse = AssignmentStatusDTO;
